// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: calendar-event.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { CompanyEventProto } from "./company_event";
import { CorporateAction } from "./corporate-action";

export const protobufPackage = "com.tick2trade.api.calendarevent";

export interface CompanyEventsAndActions {
  date: string;
  companyEvents: CompanyEventProto[];
  corporateActions: CorporateAction[];
}

export interface GetCalendarEventsResponse {
  calendarEvents: CompanyEventsAndActions[];
}

function createBaseCompanyEventsAndActions(): CompanyEventsAndActions {
  return { date: "", companyEvents: [], corporateActions: [] };
}

export const CompanyEventsAndActions = {
  encode(message: CompanyEventsAndActions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    for (const v of message.companyEvents) {
      CompanyEventProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.corporateActions) {
      CorporateAction.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompanyEventsAndActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyEventsAndActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.companyEvents.push(CompanyEventProto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.corporateActions.push(CorporateAction.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyEventsAndActions {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      companyEvents: globalThis.Array.isArray(object?.companyEvents)
        ? object.companyEvents.map((e: any) => CompanyEventProto.fromJSON(e))
        : [],
      corporateActions: globalThis.Array.isArray(object?.corporateActions)
        ? object.corporateActions.map((e: any) => CorporateAction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CompanyEventsAndActions): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.companyEvents?.length) {
      obj.companyEvents = message.companyEvents.map((e) => CompanyEventProto.toJSON(e));
    }
    if (message.corporateActions?.length) {
      obj.corporateActions = message.corporateActions.map((e) => CorporateAction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompanyEventsAndActions>, I>>(base?: I): CompanyEventsAndActions {
    return CompanyEventsAndActions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompanyEventsAndActions>, I>>(object: I): CompanyEventsAndActions {
    const message = createBaseCompanyEventsAndActions();
    message.date = object.date ?? "";
    message.companyEvents = object.companyEvents?.map((e) => CompanyEventProto.fromPartial(e)) || [];
    message.corporateActions = object.corporateActions?.map((e) => CorporateAction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCalendarEventsResponse(): GetCalendarEventsResponse {
  return { calendarEvents: [] };
}

export const GetCalendarEventsResponse = {
  encode(message: GetCalendarEventsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.calendarEvents) {
      CompanyEventsAndActions.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCalendarEventsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCalendarEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.calendarEvents.push(CompanyEventsAndActions.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCalendarEventsResponse {
    return {
      calendarEvents: globalThis.Array.isArray(object?.calendarEvents)
        ? object.calendarEvents.map((e: any) => CompanyEventsAndActions.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCalendarEventsResponse): unknown {
    const obj: any = {};
    if (message.calendarEvents?.length) {
      obj.calendarEvents = message.calendarEvents.map((e) => CompanyEventsAndActions.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCalendarEventsResponse>, I>>(base?: I): GetCalendarEventsResponse {
    return GetCalendarEventsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCalendarEventsResponse>, I>>(object: I): GetCalendarEventsResponse {
    const message = createBaseGetCalendarEventsResponse();
    message.calendarEvents = object.calendarEvents?.map((e) => CompanyEventsAndActions.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
